import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { SectionTitle } from 'shared/ui/section-title';
import { SectionInfo } from 'shared/ui/section-info';

import { getRecentlyVisitedLocations } from '../../constants';

import styles from './styles.module.scss';

interface RecentlyVisitedLocationsLayoutProps {
  children: ReactNode;
}

export const RecentlyVisitedLocationsLayout: FC<
  RecentlyVisitedLocationsLayoutProps
> = ({ children }) => {
  const { t } = useTranslation();
  const { sectionInfo, carouselId } = getRecentlyVisitedLocations(t);
  return (
    <div
      className={styles.locationsLayout}
      data-testid="recently-visited-locations"
    >
      <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between rhythm-mb-2">
        <div className="d-flex align-items-center mb-2 mb-sm-0">
          <SectionTitle classNames="m-0">{t('Recently Visited')}</SectionTitle>
          <SectionInfo
            messageText={sectionInfo}
            sectionName="recently-visited-locations"
          />
        </div>
        <div className="d-flex align-items-center">
          <div id={carouselId} />
        </div>
      </div>
      <div className="position-relative w-100">{children}</div>
    </div>
  );
};
